import styles from "./textInput.module.css";

const TextInput = ({
  placeHolder,
  value,
  onChange,
  height,
  width,
  borderRadius,
  bgColor,
  error,
  bordered = false,
}) => {
  return (
    <div style={{ height, width, borderRadius }}>
      <div
        className={`${styles.textInputWrapper} ${styles[bgColor]} ${bordered ? styles.bordered : ""} ${error ? styles.errorWrapper : ""}`}
        style={{ height, width, borderRadius }}
      >
        <input
          type="text"
          className={`${styles.textInput} ${styles[bgColor]}`}
          value={value}
          onChange={(e) => onChange(e)}
          placeholder={placeHolder}
        />
      </div>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default TextInput;
